// extracted by mini-css-extract-plugin
module.exports = {"CustomTranslateButton":"GoogleTranslate_CustomTranslateButton__tAyFJ"};